import { useLocation } from 'react-router-dom'

function useQueryParameters() {
  const { search } = useLocation()

  return new URLSearchParams(search)
}

export default useQueryParameters
